var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterProductsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0668 19.6H14.9334C15.4468 19.6 15.8668 19.18 15.8668 18.6667C15.8668 18.1533 15.4468 17.7333 14.9334 17.7333H13.0668C12.5534 17.7333 12.1334 18.1533 12.1334 18.6667C12.1334 19.18 12.5534 19.6 13.0668 19.6ZM5.6001 9.33333C5.6001 9.84667 6.0201 10.2667 6.53343 10.2667H21.4668C21.9801 10.2667 22.4001 9.84667 22.4001 9.33333C22.4001 8.82 21.9801 8.4 21.4668 8.4H6.53343C6.0201 8.4 5.6001 8.82 5.6001 9.33333ZM9.33343 14.9333H18.6668C19.1801 14.9333 19.6001 14.5133 19.6001 14C19.6001 13.4867 19.1801 13.0667 18.6668 13.0667H9.33343C8.8201 13.0667 8.4001 13.4867 8.4001 14C8.4001 14.5133 8.8201 14.9333 9.33343 14.9333Z",
    fill: "#19191D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterProductsImg);
export default __webpack_public_path__ + "static/media/filterProductsImg.b32eac8fc754a346120c27b04ce99df4.svg";
export { ForwardRef as ReactComponent };